import script from "./CrewingLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./CrewingLayout.vue?vue&type=script&setup=true&lang=js"

import "./CrewingLayout.vue?vue&type=style&index=0&id=b87e2994&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b87e2994"]])

export default __exports__